import { useState, useEffect } from 'react'
import { InsuranceDate, ExpiryEffectivityDate } from '@src/common/DatePicker';
import DocumentGallery from './DocumentGallery';
import { fetchLeadData, saveInsurancePolicy, updateLeadDetailsInStore,saveInsuranceVerification } from '@src/store/slices/insurance';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom';
import DocumentForm from "../detail/inbound-outbound-payment/Documents";
import FullPageLoader from '@common/FullPageLoader';
import { SOFT_APPROVAL_RECEIVED_TYPE, POLICY_GENERATED_TYPE, DOCUMENT_CATEGORY, ROLE_FEATURES, WITH_RULE_ENGINE_ID, WITHOUT_RULE_ENGINE, EFFECTIVITY_EXPIRY_INTERVAL, API_TYPES, STATUS_SUB_STATUS, AGENCY_VAL,INS_INSURANCE_ID_STAGE,COUNTRY_CODE,IS_FLEET_ACCOUNT,VERIFIED_STATUS} from "@src/config/constant";
import LeadRemarksButton from '../common/LeadRemarksButton';
import * as HELPER from "../../../config/helper";
import moment from 'moment';
import DocumentFormId from "../detail/inbound-outbound-payment/DocumentsId";
import { useLanguage } from '@src/context/LanguageContext';
import ReactSelect from '@common/ReactSelect';
// Define the structure of error fields for validation
type ErrFieldState = {
    qr_code:string,
    follow_up_date:string,
    status:string;
};


const UnderVerificationForm = (props: any) => {
    const commonState = useSelector((state: any) => state.common);
    const [insurancePolicyNumber, setInsurancePolicyNumber] = useState('');
    const [partner_policy_number, setPartnerPolicyNumber] = useState('');
    let [followupdate, setfollowupdate] = useState<any>(null);
    let [qrCode, setQrCode] = useState('');
    let [varificationStatus, setVerficationStatus] = useState<any>('');
    const [inputFields, setInputFields] = useState<{qr_code:any,effectivity_date: any, expiry_date: any, received_date: any}>({qr_code:null,effectivity_date: null, expiry_date: null, received_date: null});
    const [isFleetAccount, setIsFleetAccount] = useState(0);

    const {translations} = useLanguage();


    const [errField, setErrField] = useState<ErrFieldState>({
        qr_code:"",
        follow_up_date:"",
        status:""
    });

    let [loading, setLoading] = useState<boolean>(false);
    const [verificationId, setVerificationId] = useState<number>();



    // Redux hooks to dispatch actions and access state
    const dispatch: any = useDispatch()
    const insuranceState = useSelector((state: any) => state.insurance)

    const navigate = useNavigate();
    const queryParams: any = useParams();

    const formType = props.formType;

    const [submitClicked, setSubmitClicked] = useState<boolean>(false);
    const [leadDetails, setLeadDetails] = useState<any>({});

    const [filesCount, setFilesCount] = useState<number>(0);
    // eslint-disable-next-line
    const [minExpiryDate, setMinExpiryDate] = useState(moment().toDate())

    let {partner_id } = insuranceState?.leadDetail || {};
    let [btnTxt, setBtnTxt] = useState('');

    // Function to save the insurance policy template
    const saveUnderVerificationDetail = () => {
        setSubmitClicked(false);
        if (validForm()) {
            setLoading(true);
            
            const formData: any = {
                lead_id: queryParams.id,
                qr_code: qrCode,
            };
            if (followupdate) {
                formData['followup_date'] = followupdate.toISOString();
            }
            if (varificationStatus) {
                formData['verification_status'] = varificationStatus?.value;
            }

            formData['id'] = verificationId ? verificationId : null;

            saveInsuranceVerification(formData).then(async (res: any) => {

                if (res.status === 200) {
                    toast.success(res.message);


                    if (res.data && Object.keys(res.data).length) {
                        setSubmitClicked(true);
                        dispatch(updateLeadDetailsInStore({
                            ...insuranceState.leadDetail,
                            ...res.data,
                            customer_api_call: !insuranceState.leadDetail.customer_api_call
                        }));
                        setVerificationId((res?.data?.verificationId) || "");
                        if(res?.data?.verification_status===VERIFIED_STATUS){
                            nextPageRedirect();
                        }else{
                            setLoading(false);
                        }
                    } else {
                        setLoading(false);

                    }
                } else {
                    toast.error('Failed to Update');
                    setLoading(false);

                }
            }).catch((error) => {
                setLoading(false);

                toast.error('An error occurred');
            });
        }
    };

    // Function to handle changes in input fields
    const onChangeHandler = (value: any, type: string) => {
        if (type === 'qr_code') {
            setQrCode(value);
            setErrField(prev => ({...prev,qr_code: ""}));
        }

        if (type === 'follow_up_date') {
            setfollowupdate(value);
            setErrField(prev => ({...prev,follow_up_date: ""}));
        }

        if (type === 'status') {
            let btnTxt = (value.value===VERIFIED_STATUS)?translations?.commonMsg?.['Verify & Next']:translations?.commonMsg?.['save'];
            setBtnTxt(btnTxt);
            setVerficationStatus(value);
            setErrField(prev => ({...prev,status: ""}));
        }
    };


    // Validate the form fields before submitting
    const validForm = () => {
        let formIsValid = true;
        setErrField({
            qr_code:"",
            follow_up_date:"",
            status:""
        });

        if (!qrCode || qrCode.trim() === "") {
            formIsValid = false;
            setErrField(prev => ({
                ...prev,
                qr_code: "QR Code is required",
            }));
        }
        if (varificationStatus==='' || varificationStatus===null || varificationStatus===undefined) {
            formIsValid = false;
            setErrField(prev => ({
                ...prev,
                status: "Verification status is required",
            }));
        }

        return formIsValid;
    };


    // Redirect to the next page after successful update
    const nextPageRedirect = () => {

       navigate(`/details/personal-details/${queryParams.id}`);

    }


    //  Fetch insurance details when the component mounts  - type 2 is for Insurance Policy Generated
    useEffect(() => {
        if (insuranceState && insuranceState.leadDetail) {
            setQrCode((insuranceState.leadDetail.qr_code) || "")
            setfollowupdate(insuranceState.leadDetail.followup_date ? new Date(insuranceState.leadDetail.followup_date) : null)
            const statusFromApi = insuranceState.leadDetail.verification_status;
            const matchedOption = commonState?.common?.verification_status?.find(
                (opt: any) => +opt.value === +statusFromApi
            );
            setVerficationStatus(matchedOption || null);
            setVerificationId((insuranceState.leadDetail.verificationId) || "")
            setErrField((prev)=>({
                qr_code:"",
                follow_up_date:"",
                status:""
            }));
        }
        // eslint-disable-next-line
        setBtnTxt(translations?.commonMsg?.['save']);
    }, [formType, insuranceState.leadDetail]);


    useEffect(() => {
        if (formType && insuranceState.leadDetail.customer_api_call) {
            setLoading(true)
            let reqst: any = { lead_id: queryParams.id }
            let apiType = API_TYPES['underVerification']

            fetchLeadData({ ...reqst, apiType }).then((res: any) => {
                if (res && res.data && Object.keys(res.data).length) {
                    dispatch(updateLeadDetailsInStore({ ...insuranceState.leadDetail, ...res.data }))
                }
            }).finally(() => setLoading(false))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formType, insuranceState.leadDetail.customer_api_call])


    const resolveFileUpload = (filesStatus: any) => {
        setLoading(false);

        if (filesStatus.status) {
            dispatch(updateLeadDetailsInStore({ ...leadDetails, images: [...leadDetails.images, ...filesStatus.data] }));
            nextPageRedirect();

        }

    }

    const handleSoftApprovalSkip = (e: any) => {
        //SKIP IF NOT ALREADY SAVED
        if (!insuranceState?.leadDetail.soft_approval_id) {
            setLoading(true);
            e.preventDefault();

            let formData: any = {};

            formData['lead_id'] = queryParams.id;
            formData['type'] = SOFT_APPROVAL_RECEIVED_TYPE;
            formData['isSkip'] = true;


            saveInsurancePolicy(formData).then(async (res: any) => {
                if (res.status === 200) {

                    dispatch(updateLeadDetailsInStore({ ...insuranceState.leadDetail, ...res.data }));

                    navigate(`/details/insurance-policy-generated/${queryParams.id}`);

                }
                setLoading(false);

            }).catch(err => setLoading(false));
        }
    }

    const updatedFileCount = (param:any) => {
        setFilesCount(param);
        setErrField((prev)=> ({...prev, policyDocument: ''}))
    }

    const pastSixMonths = new Date(new Date().getFullYear(), new Date().getMonth() - 6, new Date().getDate())
   
    return (
        <div className="image-form-outer">
            <FullPageLoader show={loading} />
            <div className="image-tab-panel">
                <DocumentGallery formType={props?.formType} />
            </div>
            <div className="form-tab-right-panel wrapperPosition inspolicyshared">
                <div className="lead-detail-from-outer">
                    <div className="lead-form-heading">
                        <h2>
                           Under Verification
                        </h2>
                    </div>
                    <div className="lead-form-filed">

                        <div className="row">

                            <fieldset className="col-md-12">
                                <div className="material" title = {qrCode}>
                                    <input value={qrCode} id="" onChange={(e: any) => onChangeHandler(e.target.value, 'qr_code')} type="text" placeholder=" " name="qr_code" className="form-input" maxLength={500} />
                                    <label data-label={`${translations.Insurance?.['Qr_code'] || translations.commonMsg?.loading}*`} className="form-label"></label>
                                    {errField.qr_code && (
                                        <span className="error-txt qr-error">
                                            {errField['qr_code']}
                                        </span>
                                    )}
                                </div>
                            </fieldset>
                            <fieldset className="col-md-12">
                                <div className={(followupdate) ? "active-label material animation-effect" : "material animation-effect "}>
                                    <InsuranceDate
                                        onChange={(e: Date) => onChangeHandler(e, 'follow_up_date')}
                                        placeholder=""
                                        text={`${translations.Insurance?.['Follow_Up_Date'] || translations.commonMsg?.loading}`}
                                        insurancePolicyDate={followupdate}
                                        allowOnlyFutureDates={true} 
                                        disableMaxDate={true}
                                    />
                                    {errField.follow_up_date && (
                                        <span className="error-txt">
                                            {errField['follow_up_date']}
                                        </span>
                                    )}
                                </div>

                            </fieldset>
                            <ReactSelect
                                options={commonState?.common?.verification_status}
                                value={varificationStatus}
                                handleChange={(e: any, fieldKey: string) => onChangeHandler(e, fieldKey)} 
                                placeholder="Status*"
                                fieldKey="status"
                                fieldSetClassName="col-md-12"
                                isDisabled={false}
                                errorField={errField.status} 
                            />
                        </div>


                    </div>
                    <div className="btn-save-remarks m-xl-t">
                        {
                            HELPER.isUserHasUpdateAccess({ permissionID: (ROLE_FEATURES['under_verification']), accessType: 'edit', leadDetails: insuranceState.leadDetail, pageSlug: formType })

                                ?
                                <button type="button" className="btn-primary" onClick={saveUnderVerificationDetail}>{btnTxt || translations.commonMsg?.loading}</button>
                                :
                                <button type="button" className="btn-primary" disabled>{btnTxt || translations.commonMsg?.loading}</button>
                        }
                        <LeadRemarksButton leadId={queryParams.id} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UnderVerificationForm;